import React, { useCallback } from 'react';
import { Grid, CircularProgress, Typography } from '@material-ui/core';
import clsx from 'clsx';
import PropTypes from 'prop-types';

const PmsFeeScheduleCell = ({
  planPackageId,
  rowIndex,
  isDownloading,
  onDownload,
  downloadLinkClassName,
}) => {
  const handleClick = useCallback(
    (e) => {
      e.stopPropagation();
      onDownload(planPackageId, rowIndex);
    },
    [planPackageId, rowIndex, onDownload]
  );

  if (!planPackageId) return null;

  return (
    <Grid item className="d-flex align-center">
      {isDownloading ? (
        <CircularProgress thickness={5} size={20} />
      ) : (
        <Typography
          className={clsx('theme_color_orange', downloadLinkClassName)}
          fontSize="small"
          style={{ textDecoration: 'underline' }}
          component="span"
          onClick={handleClick}
          data-testid={`pms-fee-schedule-download-${rowIndex}`}
        >
          Download
        </Typography>
      )}
    </Grid>
  );
};

PmsFeeScheduleCell.propTypes = {
  planPackageId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  rowIndex: PropTypes.number.isRequired,
  isDownloading: PropTypes.bool.isRequired,
  onDownload: PropTypes.func.isRequired,
  downloadLinkClassName: PropTypes.string,
};

PmsFeeScheduleCell.defaultProps = {
  planPackageId: null,
  downloadLinkClassName: '',
};

/**
 * Wrapper that receives a render prop and calls it (does not use it as an element).
 * Satisfies the rule: render props must be called by the receiving component.
 */
export const PmsFeeScheduleCellWrapper = ({
  renderPmsFeeScheduleCell,
  value,
  rowIndex,
}) => renderPmsFeeScheduleCell(value, rowIndex);

PmsFeeScheduleCellWrapper.propTypes = {
  renderPmsFeeScheduleCell: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  rowIndex: PropTypes.number.isRequired,
};

export default PmsFeeScheduleCell;
